
import MainLayout from "@/components/layout/MainLayout";
import { TeamManagement as TeamManagementComponent } from "@/components/collaboration/TeamManagement";

const TeamManagement = () => {
  return (
    <MainLayout>
      <TeamManagementComponent />
    </MainLayout>
  );
};

export default TeamManagement;
